import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useLocation } from 'react-router-dom'

export default function SeoTags() {
  const { pathname } = useLocation()

  const [name, setName] = useState("")
  const [title, setTitle] = useState("")
  const [url, setUrl] = useState("")
  const [img, setImg] = useState("")
  const [description, setDescription] = useState("")

  useEffect(() => {
    if (pathname === "/") {
      setName("Home")
      setTitle("Top IT Services Company - Technic Mentors")
      setUrl("https://technicmentors.com/")
      setImg("https://technicmentors.com/static/media/technicblue.524a6a4b92880f2eb36b.png")
      setDescription("Enhance your business operations and technological capabilities by partnering with the ideal IT services company to provide tailored solutions and support.")
    } else if (pathname === "/about") {
      setName("About")
      setTitle("Know About Best Software Company - Technic Mentors")
      setUrl("https://technicmentors.com/about/")
      setImg("https://technicmentors.com/assets/img/technologies.webp")
      setDescription("Technic mentors is the best software company to look at when searching for extraordinary software and technology solutions.")
    } else if (pathname === "/team") {
      setName("Team")
      setTitle("Meet Our Expert Software Development Team - Technic Mentors")
      setUrl("https://technicmentors.com/team/")
      setImg("https://technicmentors.com/assets/img/team/nadeem-pic-Technic-Mentors.webp")
      setDescription("Meet the expert software development team at Technic Mentors. Our skilled professionals deliver innovative solutions tailored to your business needs.")
    } else if (pathname === "/portfolio") {
      setName("Our Portfolio")
      setTitle("Our Portfolio - Technic Mentors")
      setUrl("https://technicmentors.com/portfolio/")
      setImg("https://technicmentors.com/assets/img/portfolio-img.png")
      setDescription("Our portfolio showcases a spectrum of software services, from web and mobile app development to custom solutions, AI, blockchain, and cloud technologies.")
    } else if (pathname === "/web-development-services") {
      setName("Web Development Services")
      setTitle("Web Design & Development Services - Technic Mentors")
      setUrl("https://technicmentors.com/web-development-services/")
      setImg("https://technicmentors.com/assets/img/web-development-services.gif")
      setDescription("Web development services encompass two essential steps: web design and web development. Web design focuses on the aesthetics.")
    } else if (pathname === "/software-development-services") {
      setName("Software Development Services")
      setTitle("Software Development Services - Technic Mentors")
      setUrl("https://technicmentors.com/software-development-services/")
      setImg("https://technicmentors.com/assets/img/software-development-services.gif")
      setDescription("Software development services encompass a series of essential steps involving the developing business solutions.")
    } else if (pathname === "/mobile-app-development-services") {
      setName("Mobile App Development Services")
      setTitle("Mobile App Development Services - Technic Mentors")
      setUrl("https://technicmentors.com/mobile-app-development-services/")
      setImg("https://technicmentors.com/assets/img/mobile-app-development-services.gif")
      setDescription("Mobile app development services play a pivotal role in elevating businesses in today’s digital landscape.")
    } else if (pathname === "/seo-services") {
      setName("SEO Services")
      setTitle("Offering Best SEO Services In Pakistan - Technic Mentors")
      setUrl("https://technicmentors.com/seo-services/")
      setImg("https://technicmentors.com/assets/img/seo-services.gif")
      setDescription("Our SEO services in Pakistan involve optimizing your website to improve its ranking on search engine result pages.")
    } else if (pathname === "/digital-marketing-services") {
      setName("Digital Marketing Services")
      setTitle("Digital Marketing Services - Technic Mentors")
      setUrl("https://technicmentors.com/digital-marketing-services/")
      setImg("https://technicmentors.com/assets/img/digital-marketing.gif")
      setDescription("Digital marketing services include promoting brands via online platforms and digital communication channels.")
    } else if (pathname === "/graphics-designing-services") {
      setName("Graphics Designing Services")
      setTitle("Best Graphic Designing Services - Technic Mentors")
      setUrl("https://technicmentors.com/graphics-designing-services/")
      setImg("https://technicmentors.com/assets/img/graphics-designing-services.gif")
      setDescription("Graphics designing services involve the skilled creation of visual content aimed at conveying messages.")
    } else if (pathname === "/school-management-system") {
      setName("School Management System")
      setTitle("Best School Management Software - Technic Mentors")
      setUrl("https://technicmentors.com/school-management-system/")
      setImg("https://technicmentors.com/assets/img/erp-accounting-software.webp")
      setDescription("Manage schools, colleges, and universities with our School Management System.")
    } else if (pathname === "/business-management-solutions") {
      setName("Business Management Solutions")
      setTitle("Intelligent Business Management Software In Pakistan - Technic Mentors")
      setUrl("https://technicmentors.com/business-management-solutions/")
      setImg("https://technicmentors.com/assets/img/erp-accounting-software.webp")
      setDescription("We offer a full range of value-added ERP software and CRM services.")
    } else if (pathname === "/ecommerce-solutions") {
      setName("Ecommerce Solutions")
      setTitle("Ecommerce Software Development Services - Technic Mentors")
      setUrl("https://technicmentors.com/ecommerce-solutions/")
      setImg("https://technicmentors.com/assets/img/ecommerce-solutions.webp")
      setDescription("Our Ecommerce software development is designed to help your business thrive online.")
    } else if (pathname === "/restuarent-management-system") {
      setName("Point Of Sale")
      setTitle("Best Software For Retail Shop - Technic Mentors")
      setUrl("https://technicmentors.com/restuarent-management-system/")
      setImg("https://technicmentors.com/assets/img/point-of-sale.webp")
      setDescription("Our POS software improves efficiency and effectiveness for retail businesses.")
    } else if (pathname === "/industries") {
      setName("Industries")
      setTitle("Industries We Serve In Technologically-Driven World")
      setUrl("https://technicmentors.com/industries/")
      setImg("https://technicmentors.com/static/media/healthTech.7f3b9393fa88e356846e.webp")
      setDescription("Explore the diverse industries supported by Technic Mentors software solutions.")
    } else if (pathname === "/help") {
      setName("Help")
      setTitle("Technic Mentors Help Info")
      setUrl("https://technicmentors.com/help/")
      setImg("https://technicmentors.com/static/media/help-img.e98695db018ac2bee340.avif")
      setDescription("Visit Technic Mentors Help Center for guides and technical support.")
    } else if (pathname === "/blog") {
      setName("Blog")
      setTitle("Blogs - Technic Mentors")
      setUrl("https://technicmentors.com/blog/")
      setDescription("Explore insights, tips, and latest trends in IT on the Technic Mentors blog.")
    } else if (pathname === "/faq-page") {
      setName("FAQs")
      setTitle("FAQs - Technic Mentors")
      setUrl("https://technicmentors.com/faq-page/")
      setDescription("Find answers to common questions about our IT services.")
    } else if (pathname === "/contact") {
      setName("Contact")
      setTitle("Get In Touch With Us - Technic Mentors")
      setUrl("https://technicmentors.com/contact/")
      setDescription("Have any query? Our support team is always here to help you.")
    } else {
      setName("Technic Mentors")
      setTitle("Top IT Services Company - Technic Mentors")
      setUrl("https://technicmentors.com/")
      setImg("https://technicmentors.com/static/media/technicblue.524a6a4b92880f2eb36b.png")
      setDescription("Enhance your business operations and technological capabilities with Technic Mentors.")
    }
  }, [pathname])

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    url,
    name: "Technic Mentors",
    description,
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://technicmentors.com/search?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  }

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@TechnicMentors" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />

      {/* Schema FIXED */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />

      <link rel="canonical" href={url} />
    </Helmet>
  )
}
